var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E8D8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26656 8.54071H4.81664C4.36749 8.54071 4 8.16005 4 7.69479C4 7.22953 4.36749 6.84886 4.81664 6.84886H7.26656C7.71571 6.84886 8.0832 7.22953 8.0832 7.69479C8.0832 8.16005 7.71571 8.54071 7.26656 8.54071ZM7.26656 11.0785H4.81664C4.36749 11.0785 4 11.4592 4 11.9244C4 12.3897 4.36749 12.7704 4.81664 12.7704H7.26656C7.71571 12.7704 8.0832 12.3897 8.0832 11.9244C8.0832 11.4592 7.71571 11.0785 7.26656 11.0785ZM18.6015 16.3994L16.0536 13.7601C15.3513 14.2338 14.5101 14.5045 13.6037 14.4538C11.6682 14.3607 10.0105 12.7957 9.74914 10.8078C9.38982 7.97394 11.7499 5.57996 14.5101 6.06214C16.1026 6.3413 17.4255 7.62711 17.7767 9.25975C18.0462 10.4948 17.7849 11.6453 17.2051 12.5589L19.7611 15.2066C20.0796 15.5365 20.0796 16.0695 19.7611 16.3994C19.4426 16.7293 18.92 16.7293 18.6015 16.3994ZM16.2496 10.2326C16.2496 8.83679 15.1471 7.69479 13.7997 7.69479C12.4522 7.69479 11.3498 8.83679 11.3498 10.2326C11.3498 11.6284 12.4522 12.7704 13.7997 12.7704C15.1471 12.7704 16.2496 11.6284 16.2496 10.2326ZM4.81664 17H11.3498C11.7989 17 12.1664 16.6193 12.1664 16.1541C12.1664 15.6888 11.7989 15.3081 11.3498 15.3081H4.81664C4.36749 15.3081 4 15.6888 4 16.1541C4 16.6193 4.36749 17 4.81664 17Z",
    fill: "#4E09AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.fdfa1661386ccf0997114612af662b98.svg";
export { ForwardRef as ReactComponent };